import { DownloadService } from "../services/download-service";
import { $ } from "../utils/dom";

export class Download {
  private static singleton: Download;
  // download button
  private $el: HTMLButtonElement;
  private service: DownloadService;

  constructor() {
    this.$el = $("#js__download") as HTMLButtonElement;
    this.service = new DownloadService();
  }

  public init() {
    this.$el.addEventListener("click", this.download.bind(this));
  }

  public download() {
    this.service.download();
  }

  /**
   * Creates an unique instance of AppComponent
   *
   * @readonly
   * @static
   * @type {AppComponent}
   * @memberof AppComponent
   */
  public static get instance(): Download {
    if (!Download.singleton) {
      Download.singleton = new Download();
    }
    return Download.singleton;
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/components/download.ts